import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { BackButton, ComboBoxIndex, IComboBoxIndex, IComboOption } from '@sky-it-elections/design-system';

import { isValidUrl } from '../../utils/string-utils';

export interface IComboBoxWrapper {
  isLoading?: boolean;
  isDisabled?: boolean;
  options: Array<IComboOption>;
  placeholder: string;
  value?: string;
  url?: string;
}

const ComboBoxWrapper: FC<IComboBoxWrapper> = ({
  /* istanbul ignore next: default value */ isLoading = false,
  /* istanbul ignore next: default value */ isDisabled = false,
  /* istanbul ignore next: default value */ options,
  /* istanbul ignore next: default value */ value = '',
  placeholder,
  url = '',
}) => {
  const comboBoxArgs: IComboBoxIndex = {
    isLoading,
    isDisabled,
    options,
    selected: value,
    placeholder,
  };

  const showBackButton: boolean = isValidUrl(url);

  const onClickBackButtonCallback = () => {
    if (isValidUrl(url)) {
      window.location.assign(url);
    }
  };

  const onClickComboBoxCallback = (e: IComboOption) => {
    const dataUrl = e?.url as string;
    if (isValidUrl(dataUrl)) {
      window.location.assign(dataUrl);
    }
  };

  return (
    <div className="ele__combo-box--outer-container">
      {showBackButton && <BackButton url={url} onClickCallback={onClickBackButtonCallback} />}
      <ComboBoxIndex {...comboBoxArgs} onClickCallback={onClickComboBoxCallback} />
    </div>
  );
};

ComboBoxWrapper.propTypes = {
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  options: PropTypes.arrayOf<IComboOption>(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    }).isRequired
  ).isRequired,
  placeholder: PropTypes.string.isRequired,
  url: PropTypes.string,
  value: PropTypes.string,
};

ComboBoxWrapper.defaultProps = {
  isLoading: false,
  isDisabled: false,
  value: '',
  url: '',
};

export default ComboBoxWrapper;
